// extracted by mini-css-extract-plugin
export default {"mainText":"MainText_mainText__AHaTt"};